export const round = (num: number, precision = 6) => {
  const factor = Math.pow(10, precision);
  return Math.round(num * factor) / factor;
};
